import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SearchBarState {
  isWidgetActive: boolean;
  isAllFiltersActive: boolean;
  presentFilters: string[];
}

const initialState: SearchBarState = {
  isWidgetActive: false,
  isAllFiltersActive: false,
  presentFilters: [],
};

const searchBarStateSlice = createSlice({
  name: 'searchBarState',
  initialState,
  reducers: {
    setIsAllFiltersActive: (state, action: PayloadAction<boolean>) => {
      state.isAllFiltersActive = action.payload;
    },
    setPresentFilters: (state, action: PayloadAction<string[]>) => {
      const newFilters = action.payload.filter((filter) => !state.presentFilters.includes(filter));
      state.presentFilters = [...state.presentFilters, ...newFilters];
    },
  },
});

export const { setIsAllFiltersActive, setPresentFilters } = searchBarStateSlice.actions;
export default searchBarStateSlice.reducer;
